import { ContentfulHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { HomepageProps } from '../../views/Homepage/Homepage';
import { ToProductCarouselBaseOptions } from './CarouselTransformer/CarouselTransformer';
import { ListingBlockTransformer } from './ListingBlockTransformer';

export abstract class HomepageTransformer {
  static toHomepageProps = (entry: ContentfulHomepage, options: ToProductCarouselBaseOptions = {}): HomepageProps => {
    return {
      sections: entry.fields?.sections ?? [],
      categoryListingBlock: ListingBlockTransformer.toListingBlockProps(entry.fields?.categoryListingBlock, options),
    };
  };
}
